<template>
  <Transition
    enter-from-class="opacity-0"
    enter-active-class="motion-snug"
    leave-to-class="opacity-0"
    leave-active-class="motion-snug"
  >
    <slot />
  </Transition>
</template>
